/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Action, ActionReducer, ActionReducerFactory, ActionReducerMap } from '@ngrx/store';
import { Resource, ResourceUri } from '@ngxp/rest';
import { createEmptyStateResource, ListResource, StateResource } from '../resource/resource.util';
import { TypedActionCreatorWithProps } from './actions';

export interface SingleResourceState {
  resource: StateResource<Resource>;
}

export const initialResourceState: SingleResourceState = {
  resource: createEmptyStateResource(),
};

export interface ListResourceState {
  listResource: StateResource<ListResource>;
  createdListItemResource?: StateResource<Resource>;
}

export const initialListResourceState: ListResourceState = {
  listResource: createEmptyStateResource(),
};

export interface AdditionalFeatureState {}

export interface AdditionalFeatureKey<S = AdditionalFeatureState, A = Action> {
  key: string;
  reducerFn: (state: S, action: A) => any;
}

export interface FeatureInfo<S = AdditionalFeatureState, A = Action> {
  stateName: string;
  resourcePath: string;
  listResourcePath: string;
  additionalFeature?: AdditionalFeatureKey<S, A>[];
  concurrentModificationAction?: TypedActionCreatorWithProps<{ effectedResourceUri: ResourceUri }>;
}
export interface StoreFeature<T, V extends Action = Action> {
  key: string;
  reducers: ActionReducerMap<T, V> | ActionReducer<T, V>;
  reducerFactory: ActionReducerFactory<T, V>;
  initialState?: InitialState<T>;
  metaReducers?: MetaReducer<T, V>[];
}

type InitialState<T> = Partial<T> | TypeId<Partial<T>> | void;
type MetaReducer<T = any, V extends Action = Action> = (reducer: ActionReducer<T, V>) => ActionReducer<T, V>;
type TypeId<T> = () => T;
